import React, { Fragment, useState, useEffect } from "react";
import "./otherSpecialist.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CardSpecialistOther from "../../atoms/card-specialist-other/cardSpecialistOther";

interface OtherSpecialistInterface {
  allSpecialist: any;
  selectSpecialist: any;
  pageActive: any;
  setSelectSpecialist: any;
  setdate: any;
  sethour: any;
}

const otherSpecialist = (props: OtherSpecialistInterface) => {
  const {
    allSpecialist,
    selectSpecialist,
    setSelectSpecialist,
    pageActive,
    setdate,
    sethour,
  } = props;
  const [, setcardActvie] = useState("");
  const [width, setwidth] = useState(window.screen.width);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const shortSpecialist = () => {
    let array1 = [];
    let array2 = [];

    allSpecialist &&
      allSpecialist.map((el) => {
        if (el.id.indexOf(selectSpecialist.id) === -1) {
          array1.push(el);
        }
      });

    if (array1.length >= 3) {
      for (let i = 0; i < 3; i++) {
        array2.push(array1[i]);
      }
      return array2;
    }

    return array1;
  };
  const nwSelect = (specialista) => {
    setSelectSpecialist(specialista);
    setdate("");
    sethour("");
  };
  const viewMore = () => {
    pageActive(2);
  };

  useEffect(() => {
    const handleResize = () => {
      setwidth(window.screen.width);
    };
    window.addEventListener("resize", handleResize);
  });

  return (
    <div className="m-otherSpecialist">
      <hr className="m-otherSpecialist__line" />
      <div className="m-otherSpecialist__header">
        <div className="m-otherSpecialist__header__title">
          <p>Otros profesionales que te pueden interesar</p>
        </div>
        <div className="m-otherSpecialist__header__more">
          <p onClick={viewMore}>Ver más</p>
        </div>
      </div>
      <div className="m-otherSpecialist__content">
        {width > 960 ? (
          shortSpecialist().map((specialist, index) => (
            <Fragment key={`specialist-${index}`}>
              <CardSpecialistOther
                specialist={specialist}
                others={true}
                setcardActvie={setcardActvie}
                onAction={nwSelect}
              />
            </Fragment>
          ))
        ) : (
          <Slider {...settings} className="show-on-movile">
            {shortSpecialist().map((specialist, index) => (
              <Fragment key={`specialist-${index}`}>
                <CardSpecialistOther
                  specialist={specialist}
                  others={true}
                  setcardActvie={setcardActvie}
                  onAction={nwSelect}
                />
              </Fragment>
            ))}
          </Slider>
        )}
      </div>
    </div>
  );
};

export default otherSpecialist;
